<div class="container-errMessage">
  <h1>Oops! Something went wrong.</h1>
  <p>Sorry for the inconvenience. Try refreshing the page or going back to the <a [routerLink]="['/home']">homepage</a>.</p>
  <p>If you continue to experience problems, please contact your administrator.</p>
</div>
